import { apiService } from '@/utils/api';
import { SitesResponse } from '@/types/api';

/**
 * Get all sites for the current user
 * @returns Promise with sites data
 */
export const getSites = async (): Promise<SitesResponse> => {
  try {
    return await apiService.get<SitesResponse>('/api/v1/user/sites');
  } catch (error) {
    console.error('Failed to fetch sites:', error);
    throw error;
  }
};

// Assign an unlinked device to a target site via backend API
export const assignDeviceToSite = async (deviceObjectId: string, siteObjectId: string): Promise<void> => {
  await apiService.post<{ message: string }>(
    `/api/v1/iot-shadow/device/${deviceObjectId}/assignToSite`,
    {
      device_object_id: deviceObjectId,
      site_object_id: siteObjectId,
    }
  );
};

// Refresh user's sites (re-pull from Parse and persist mapping)
export const refreshSites = async (): Promise<void> => {
  await apiService.post<{ message: string }>(
    '/api/v1/user/refreshSite',
    {}
  );
};